import { useEffect, useState } from 'react'
import { useUserListLazyQuery } from '~/graphql/types'
import { UserListData } from '~/contexts/users/types'

const TARGET_PROFILES = ['Analista de Backoffice', 'Vendedor', 'Analista de Parcerias']

export const useUsersWithProfiles = () => {
  const [filteredUsers, setFilteredUsers] = useState<UserListData>([])
  const [getUserList, { data, loading }] = useUserListLazyQuery()

  useEffect(() => {
    // Fetch all users when hook is initialized
    getUserList({
      variables: {
        params: {
          pageSize: 1000, // Get a large number to include all users
        }
      }
    })
  }, [getUserList])

  useEffect(() => {
    if (data?.userList?.data) {
      // Filter users by target profiles
      const filtered = data.userList.data.filter(user => 
        user.accessControlRef && 
        TARGET_PROFILES.includes(user.accessControlRef.name) &&
        user.status === 'active'
      )
      setFilteredUsers(filtered)
    }
  }, [data])

  // Convert to options format for Select component
  const userOptions = filteredUsers.map(user => ({
    value: user._id,
    label: user.name
  }))

  return {
    users: filteredUsers,
    userOptions,
    loading,
    refetch: getUserList
  }
}
